import React from 'react';

const CrossLinks = ({ links }) => (
  <>
    <div className="mb-4 grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4">
      {links.map(link => {
        return (
          <div className="mb-4" key={link.url}>
            <a href={link.url} className="inline-block text-gray-900 hover:underline">
              <h3 className="pb-0 mb-0 text-xl font-medium">{link.title}</h3>
            </a>
          </div>
        );
      })}
    </div>
  </>
);

export default CrossLinks;
